import anime from 'animejs';

export default async ( targets ) => {
  const duration = 100;
  const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;

  const anim = anime.timeline( {
    easing: 'easeInOutQuart',
    duration,
  } );

  anim.add( {
    targets: targets,
    marginTop: 0,
  }, '0' );


  anim.add({
    targets: scrollElement,
    scrollTop: 0,
  }, '0' );

  return anim.finished;
};
